// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')

const bem = BemEntity('UploadImageModalPlaceholder')

class UploadImageModalPlaceholder extends React.PureComponent {
  constructor(props) {
    super(props)

    this.inputRef = React.createRef()

    this.onBrowseFilesClick = this.onBrowseFilesClick.bind(this)
    this.onPlaceholderInputChange = this.onPlaceholderInputChange.bind(this)
  }

  // Event handler methods

  onBrowseFilesClick(event) {
    event.preventDefault()
    this.inputRef.current.click()
  }

  onPlaceholderInputChange(event) {
    this.props.onFileSelect(event.target.files[0])
  }

  // Render methods

  renderCallToAction() {
    return tag('p', {
      className: bem.element('call-to-action')
    },
      'Drag and drop, or ',
      tag('a', {
        className: bem.element('link'),
        onClick: this.onBrowseFilesClick
      },
        'browse files'
      ),
      ' to upload'
    )
  }

  renderImage() {
    const { imagePurpose } = this.props
    return tag('div', {
      className: bem.element('image-mask', imagePurpose)
    },
      tag(LazyImage, {
        className: bem.element('image'),
        sources: [this.props.imageUrl]
      }),
      tag('input', {
        ref: this.inputRef,
        className: bem.element('input'),
        type: 'file',
        onChange: this.onPlaceholderInputChange
      })
    )
  }

  renderTips() {
    const { tips } = this.props
    return tag('ul', {
      className: bem.element('tips')
    },
      ...tips.map(tip => this.renderTip(tip))
    )
  }

  renderTip(text) {
    return tag('li', {
      className: bem.element('tip')
    },
      text
    )
  }

  render() {
    return tag('section', {
      className: classNames(
        this.props.className,
        bem.block()
      )
    },
      this.renderImage(),
      tag('div', {
        className: bem.element('padding')
      },
        this.renderCallToAction(),
        this.renderTips()
      )
    )
  }
}

UploadImageModalPlaceholder.propTypes = {
  // Values
  className: PropTypes.string,
  imagePurpose: PropTypes.string,
  imageUrl: PropTypes.string,
  tips: PropTypes.arrayOf(PropTypes.string).isRequired,
  // Callbacks
  onFileSelect: PropTypes.func
}

module.exports = UploadImageModalPlaceholder
